/**
 * Server Role
 */
export class ServerRole {
    client;
    serverId;
    id;
    name;
    permissions;
    colour;
    hoist;
    rank;
    /**
     * Construct server role
     * @param client Client
     * @param serverId Server ID
     * @param id Role ID
     * @param data Role data
     */
    constructor(client, serverId, id, data) {
        this.client = client;
        this.serverId = serverId;
        this.id = id;
        this.name = data.name;
        this.permissions = {
            a: BigInt(data.permissions?.a ?? 0),
            d: BigInt(data.permissions?.d ?? 0)
        };
        this.colour = data.colour ?? undefined;
        this.hoist = data.hoist || false;
        this.rank = data.rank ?? 0;
    }
    /**
     * Write to string as a role mention
     * @returns Formatted String
     */
    toString() {
        return `<%${this.id}>`;
    }
    /**
     * Server attached to this role
     */
    get server() {
        return this.client.servers.get(this.serverId);
    }
    /**
     * Whether this role is assigned to our server member
     */
    get assigned() {
        return this.server?.member?.roles.includes(this.id) || false;
    }
    /**
     * Delete this role.
     *
     * 404 from the backend is treated as success — the role is already
     * gone, which is the outcome the caller wanted. Avoids a confusing
     * "Could not find what you requested" modal when two browser tabs
     * race a delete, or when the user refreshes after confirming.
     */
    async delete() {
        try {
            return await this.client.api.delete(`/servers/${this.serverId}/roles/${this.id}`);
        }
        catch (error) {
            // stoat-api throws the response body (not a wrapped error) on non-2xx.
            // For 404 the body shape is { type: "NotFound", ... }. Treat as success:
            // the role is already gone, which is the outcome the caller wanted.
            const errorType = error?.type;
            if (errorType === "NotFound") {
                return undefined;
            }
            throw error;
        }
    }
}
